// src/pages/Editor.tsx
import { useParams } from 'react-router-dom'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { EditorShell } from '@/features/editor/components/studio/EditorShell'

const Editor = () => {
  const { courseId } = useParams<{ courseId: string }>()
  const id = Number(courseId)
  const m = useMessages(messages)
  if (!Number.isFinite(id)) return <div className="p-6">{m.invalidCourseId}</div>
  return <EditorShell courseId={id} />
}

export default Editor
